import { PaidPayment, PaymentProduct } from 'src/models/payment';
import RootState from '../../rootState';

export class Action {
    type: string;
    paidProducts: PaidPayment;
    paymentProducts: Array<PaymentProduct>;
    errorMessage: string;
    messageType: string;
}

export interface State {
    submitting: boolean;
    submitted: boolean;

    loading: boolean;
    paymentProducts: Array<PaymentProduct>;
    errorMessage: string;
    messageType: string;
}

export const types = {
    ACTION_SERVER_DATA_PAYMENT_REQUESTED: 'ACTION_SERVER_DATA_PAYMENT_REQUESTED',
    ACTION_SERVER_DATA_PAYMENT_FAILED: 'ACTION_SERVER_DATA_PAYMENT_FAILED',

    SUBMIT_PAID_PRODUCTS_ASYNC: 'SUBMIT_PAID_PRODUCTS_ASYNC',
    SUBMIT_PAID_PRODUCTS_SUCCEED: 'SUBMIT_PAID_PRODUCTS_SUCCEED',

    GET_PAYMENT_PRODUCTS_LOADING: 'GET_PAYMENT_PRODUCTS_LOADING',
    GET_PAYMENT_PRODUCTS_ASYNC: 'GET_PAYMENT_PRODUCTS_ASYNC',
    GET_PAYMENT_PRODUCTS_SUCCEED: 'GET_PAYMENT_PRODUCTS_SUCCEED',
    GET_PAYMENT_PRODUCTS_FAILED: 'GET_PAYMENT_PRODUCTS_FAILED',
};

const baseAction = new Action();

export const actions = {
    actionServerDataPaymentRequested: (): Action => ({
        ...baseAction,
        type: types.ACTION_SERVER_DATA_PAYMENT_REQUESTED
    }),

    actionServerDataPaymentFailed: (errorMessage: string, messageType: string): Action => ({
        ...baseAction,
        type: types.ACTION_SERVER_DATA_PAYMENT_FAILED,
        errorMessage,
        messageType
    }),

    submitPaidProductsAsync: (paidProducts: PaidPayment): Action => ({
        ...baseAction, type: types.SUBMIT_PAID_PRODUCTS_ASYNC,
        paidProducts
    }),

    submitPaidProductsSucceeded: (): Action => ({
        ...baseAction,
        type: types.SUBMIT_PAID_PRODUCTS_SUCCEED
    }),

    getPaymentProductsAsync: (): Action => ({
        ...baseAction,
        type: types.GET_PAYMENT_PRODUCTS_ASYNC
    }),

    getPaymentProductsLoading: (): Action => ({
        ...baseAction,
        type: types.GET_PAYMENT_PRODUCTS_LOADING
    }),

    getPaymentProductsSucceeded: (paymentProducts: Array<PaymentProduct>): Action => ({
        ...baseAction,
        type: types.GET_PAYMENT_PRODUCTS_SUCCEED,
        paymentProducts
    }),

    getPaymentProductsFailed: (): Action => ({
        ...baseAction,
        type: types.GET_PAYMENT_PRODUCTS_FAILED
    }),
};

export const selectors = {
    getState: (rootState: RootState): State => rootState.entities.paymentData,
    
    submitting(rootState: RootState): boolean {
        const { submitting } = this.getState(rootState);
        return submitting;
    },

    submitted(rootState: RootState): boolean {
        const { submitted } = this.getState(rootState);
        return submitted;
    },

    loading(rootState: RootState): boolean {
        const { loading } = this.getState(rootState);
        return loading;
    },

    getPaymentProducts(rootState: RootState): Array<PaymentProduct> {
        const { paymentProducts } = this.getState(rootState);
        return paymentProducts;
    },

    errorMessage(rootState: RootState): string {
        const { errorMessage } = this.getState(rootState);
        return errorMessage;
    },

    messageType(rootState: RootState): string {
        const { messageType } = this.getState(rootState);
        return messageType;
    },
};


// WEBPACK FOOTER //
// ./src/modules/entities/payment/index.ts